import React, { Fragment } from 'react';
import Header from '../../components/Header/Header';
import Hero from '../../components/hero/hero';
import Start from '../../components/business/Start/start';
import ProcessTechnology from '../../components/business/ProcessTechnology/ProcessTechnology';
import FaqSection from '../../components/business/FaqSection/FaqSection';
import Scrollbar from '../../components/scrollbar/scrollbar';
import ContactSection from '../../components/business/ContactSection';
import Footer from '../../components/business/Footer/Footer';
import OnzeVisie from "../../components/business/OnzeVisie/OnzeVisie";
import OverOns from "../../components/business/OverOns/OverOns";

const Homepage = () => {

    return (
        <Fragment>
            <div>
                <Header />
                <main className="page_content">
                    <Hero />
                    <Start />
                    <OnzeVisie />
                    <OverOns />
                    <ProcessTechnology />
                    <FaqSection />
                    <ContactSection />
                </main>
                <Footer />
                <Scrollbar />
            </div>
        </Fragment>
    )
};
export default Homepage;